<label [for]="customId ?? 'organisation-select'" class="form-label">
  {{ 'admin.organisation' | translate }}
</label>

<input
    [id]="customId ?? 'organisation-select'"
    type="text"
    class="form-control form-select"
    [formControl]="organisation"
    [placeholder]="placeholder ?? 'admin.allOrganisations' | translate"
    popupClass="ngb-typeahead-window-organisation-selector"
    [ngbTypeahead]="search"
    [resultFormatter]="resultFormatter"
    [resultTemplate]="rt"
    [inputFormatter]="inputFormatter"
    [editable]="false"
    (focus)="focus$.next($any($event).target.value)"
    (click)="click$.next($any($event).target.value)"
    [class.is-invalid]="organisation.invalid && organisation.touched"
    (selectItem)="onSelected($event, input)"
    #input
    #instance="ngbTypeahead"
/>

<ng-template #rt let-r="result" let-t="term">
  <div [class.disabled]="r.disabled">
    <ngb-highlight [result]="resultFormatter(r)" [term]="t"></ngb-highlight>
  </div>
</ng-template>